import { useAppSelector } from '@hooks/app/redux';
import { createProviderMerchants } from '@services/external/software-provider.api';
import { useMutation } from 'react-query';
import { TCreateMerchantParams } from 'types/software-provider.types';
import type { UseMutationOptions } from 'react-query';

function useCreateSoftwareMerchant(
  options?: UseMutationOptions<void, unknown, TCreateMerchantParams, unknown>,
) {
  const providerId = useAppSelector((state) => state.users.currentProvider?.id)!;

  return useMutation(
    ['softwareProvider:create', providerId],
    async (data: TCreateMerchantParams) => {
      await createProviderMerchants(providerId, data);
    },
    options,
  );
}

export default useCreateSoftwareMerchant;
